import { GraduationCap, HeartHandshake, Presentation, Network, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";

const pillars = [
  {
    icon: GraduationCap,
    title: "Reclaiming Tigerhood",
    copy: "On-campus programs for adolescents in Child Care Institutions. Career readiness, emotional resilience, life skills \u2014 delivered in partnership with the institution.",
    id: "reclaiming-tigerhood",
  },
  {
    icon: HeartHandshake,
    title: "Careleavers Support",
    copy: "Community, employment help, and one-on-one support for young adults who\u2019ve aged out of care. Online where it needs to be, in person where it matters.",
    id: "careleavers-support",
  },
  {
    icon: Presentation,
    title: "Capacity Building",
    copy: "Workshops and training for caregivers, educators, and CCI staff. Built around our BEAT Psychology Framework and Mind Gym approach.",
    id: "capacity-building",
  },
  {
    icon: Network,
    title: "Resource Network",
    copy: "We plug into a network of skilling partners, employers, and sector organisations so care leavers reach the right opportunity at the right time.",
    id: "resource-network",
  },
];

export const Pillars = () => (
  <section id="our-work" className="py-24 md:py-36" data-testid="pillars-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="max-w-2xl">
        <SectionLabel testId="pillars-label">What We Do</SectionLabel>
        <h2
          className="font-heading text-3xl sm:text-4xl md:text-[2.75rem] font-semibold tracking-tight text-[#1F2043] leading-[1.15]"
          data-testid="pillars-headline"
        >
          Four pillars. One goal.
        </h2>
      </Reveal>
      <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {pillars.map((pillar, i) => (
          <Reveal key={pillar.id} delay={(i % 2) * 0.1} testId={`pillar-card-${pillar.id}`} className="h-full">
            <div className="card-soft p-8 md:p-11 h-full flex flex-col">
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-2xl bg-[#00867A]/10 flex items-center justify-center">
                  <pillar.icon className="w-6 h-6 text-[#00867A]" strokeWidth={1.6} />
                </div>
                <span className="font-heading text-sm font-medium text-[#00867A]/35 tracking-widest">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-heading mt-7 text-xl md:text-2xl font-semibold text-[#1F2043] tracking-tight">
                {pillar.title}
              </h3>
              <p className="font-body mt-3.5 text-base font-light leading-relaxed text-[#3C3C3B]">
                {pillar.copy}
              </p>
              <a
                href="#contact"
                data-testid={`pillar-cta-${pillar.id}`}
                className="group mt-auto pt-7 inline-flex items-center gap-2 font-heading text-sm font-medium text-[#00867A] hover:text-[#1F2043] transition-colors duration-300"
              >
                Talk to us about this
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
